var map = {
	"./bari.png": "f943",
	"./bergamo.png": "fcb9",
	"./bolzano.png": "03e2",
	"./brescia.png": "4f98",
	"./chieti-pescara.png": "7e7d",
	"./como-lecco.png": "a2ff",
	"./cremona.png": "3ba7",
	"./firenze.png": "3423",
	"./genova.png": "0a87",
	"./laquila.png": "d2e7",
	"./lecco.png": "9b01",
	"./mantova.png": "2a06",
	"./messina.png": "3e8d",
	"./milano.png": "85e8",
	"./nuoro.png": "015f",
	"./padova.png": "814f",
	"./palermo-enna.png": "5a6d",
	"./pavia.png": "954d",
	"./pordenone-udine.png": "5427",
	"./rieti.png": "547c",
	"./riviere-liguria.png": "26c5",
	"./salerno.png": "6bd2",
	"./sardegna.png": "ddee",
	"./sondrio.png": "ee06",
	"./treviso-belluno.png": "6695",
	"./varese.png": "c757",
	"./venezia-giulia.png": "b7dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a0";